import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'brave-search',
  name: 'Brave Search Tool',
  category: 'tools',
  description: 'Search the web using Brave Search API with advanced filtering and AI agent integration',
  icon: 'siBrave',
  color: 'green',
  version: '1.0.0',
  
  group: ['transform'],
  
  defaults: {
    name: 'Brave Search',
    color: 'green'
  },
  
  subtitle: '={{$parameter["query"] || "Configure search"}}',
  
  credentials: [
    {
      name: 'braveSearchApi',
      displayName: 'Brave Search API',
      required: true
    }
  ],
  
  inputs: [
    {
      name: 'main',
      type: 'main',
      displayName: 'Input',
      required: false
    }
  ],
  
  outputs: [
    {
      name: 'main',
      type: 'main',
      displayName: 'Output'
    }
  ],
  
  tags: ['search', 'web', 'brave', 'internet', 'query', 'api'],
  
  comingSoon: false,
  
  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'brave_search',
    description: 'Search the web using Brave Search API. Returns web results with titles, URLs, descriptions, and metadata. Supports filtering by country, language, content safety, and recency.',
    allowManualDescription: true,
    parameters: {
      query: {
        toolParamName: 'query',
        description: 'The search query string (max 400 characters, 50 words)',
        required: true,
        type: 'string'
      },
      count: {
        toolParamName: 'count',
        description: 'Number of results to return (1-20)',
        required: false,
        type: 'number'
      },
      country: {
        toolParamName: 'country',
        description: 'Country code for localized results (e.g., US, GB, DE)',
        required: false,
        type: 'string'
      },
      safesearch: {
        toolParamName: 'safesearch',
        description: 'Safe search level: off, moderate, or strict',
        required: false,
        type: 'string',
        enum: ['off', 'moderate', 'strict']
      },
      freshness: {
        toolParamName: 'freshness',
        description: 'Time range for results: any, day, week, month, or year',
        required: false,
        type: 'string',
        enum: ['any', 'day', 'week', 'month', 'year']
      },
      search_lang: {
        toolParamName: 'search_lang',
        description: 'Language code for search (e.g., en, es, fr)',
        required: false,
        type: 'string'
      },
      offset: {
        toolParamName: 'offset',
        description: 'Pagination offset (0-9)',
        required: false,
        type: 'number'
      },
      spellcheck: {
        toolParamName: 'spellcheck',
        description: 'Enable spell checking and query correction',
        required: false,
        type: 'boolean'
      },
      text_decorations: {
        toolParamName: 'text_decorations',
        description: 'Include text decorations in results',
        required: false,
        type: 'boolean'
      },
      result_filter: {
        toolParamName: 'result_filter',
        description: 'Filter results by type: web, news, videos, images',
        required: false,
        type: 'array'
      }
    },
    outputMapping: {
      results: 'Array of search results with title, url, description, snippet',
      query: 'Query information including original, corrected, and warnings',
      metadata: 'Search metadata including total results, country, language'
    },
    timeout: 30000 // 30 second timeout for search operations
  }
};

export default definition;
